function registerForm(){
    $('form[name="register_form"]').addClass('ready');

    $('form[name="register_form"]').validate({
        focusCleanup: true,
        rules: {
            'name':'required',
            'surname':'required',
            'email':{
                required: true,
                email: true
            },
            'email_verify':{
                required: true,
                email: true,
                equalTo: "#email"
            },
            'password':{
                required:true
            },
            'password_verify':{
                required: true,
                equalTo: "#password"
            },
            'country':'required',
            'accept_terms':'required',
			'disclaimer':{
				required:"#newsletter:checked"
			}  
			
        },
        messages:{
            'name':'Required',
            'surname':'Required',
            'email':'Required',
            'password':'Required',
            'password_verify':'Required',
            'country':'Required',
            'accept_terms':'Required'
        },
        submitHandler: function() {
            $('.register_form .has-spinner').addClass('active');
            $.ajax({data:$('form[name="register_form"]').serialize(),success:function(data){
                $('.register_form .has-spinner').removeClass('active');
                grecaptcha.reset();
                if(data.status == 'ok'){
                    form_submit_response('form[name="register_form"]','success',data.message,true);
                }else if(data.status == 'error') {
                    form_submit_response('form[name="register_form"]','danger',data.error);
                }else{
                    form_submit_response('form[name="register_form"]','danger','An unknown error occurred. Please contact support@fnl-guide.com');
                }
            }});
        }
    });
}
function updateAccountForm(){
    $('form[name="my_account_form"]').addClass('ready');
    $('form[name="my_account_form"]').validate({
        rules: {
            'name':'required',
            'surname':'required',
            'username':'required',
            'password': {
                minlength: 5
            },
            'password_verify': {
                minlength: 5,
                equalTo: "#password"
            },
            'accept_terms':'required',
			'disclaimer':{
				required:"#newsletter:checked"
			}  
        },
        messages:{
            'name':'Required',
            'surname':'Required',
            'username':'Required',
            'password':{
                minlength: "! Must be at least 5 characters long"
            },
            'password_verify':{
                required: 'Required',
                minlength: "! Must be at least 5 characters long"
            },
            'accept_terms':'Required'
        },
        submitHandler: function() {
            $.ajax({data:$('form[name="my_account_form"]').serialize(),success:function(data){
                grecaptcha.reset();

                if(data.status == 'ok'){
                    form_submit_response('form[name="my_account_form"]','success',data.user_msg,true);
                }else if(data.status == 'error') {
                    form_submit_response('form[name="my_account_form"]','danger',data.error);
                }else{
                    form_submit_response('form[name="my_account_form"]','danger','An unknown error occurred. Please contact support@fnl-guide.com');
                }
            }});
        }
    });
}
function getHash(){
    var hash = window.location.hash;
    return hash.substring(2); // remove #!
}
function loginForm(target){
    $('form[name="'+target+'"]').addClass('ready');

    $('form[name="'+target+'"]').validate({
        focusCleanup: true,
        rules: {
            'email':{
                required: true,
                email: true
            },
            'password':{
                required:true
            }
        },
        messages:{
            'email':'Required',
            'password':'Required'
        },
        submitHandler: function() {
            $('.login_form .has-spinner').addClass('active');
            
			$.ajax({data:$('form[name="'+target+'"]').serialize(),success:function(data){
               
                if(data.status == 'ok'){
                    location.reload();
	               	$('form[name="'+target+'"] .has-spinner.active').removeClass('active');
			    }else if(data.status == 'error') {
                    if(typeof(data.callback) !== 'undefined'){
                        var email = $('form[name="'+target+'"] input[name="email"]').val();
                        eval(data.callback + '("' + data.error + '","' + email + '")');
                    	 $('form[name="'+target+'"] .has-spinner.active').removeClass('active');
					}else{
                        form_submit_response('form[name="'+target+'"]','danger', data.error);
						 $('form[name="'+target+'"] .has-spinner.active').removeClass('active');
                    }
                }else{
                    form_submit_response('form[name="'+target+'"]','danger','An unknown error occurred. Please contact support@fnl-guide.com');
					 $('form[name="'+target+'"] .has-spinner.active').removeClass('active');
                }

            }});
        }
    });
}
function resend_activation_email(message,email){
    message += ' Resend activation email?';
    var r=confirm(message);
    if (r==true){
        $.ajax({data:{module:'members','action':'send-activation-email',email:email},success:function(data){
            if(data.status == 'ok'){
                form_submit_response('','success','Activation email succesfully sent',true);
            }else if(data.status == 'error') {
                form_submit_response('form[name="login_form"]','danger',data.error);
            }else{
                form_submit_response('form[name="login_form"]','danger','An unknown error occurred. Please contact support@fnl-guide.com');
            }

        }});
    }
}
function forgotPasswordForm(){
    $('form[name="forgot_password_form"]').addClass('ready');
    $('form[name="forgot_password_form"]').validate({
        rules: {
            'email':'required'
        },
        messages:{
            'email':'Required'
        },
        submitHandler: function() {
            $('form[name="forgot_password_form"] .has-spinner').addClass('active');

            $.ajax({data:$('form[name="forgot_password_form"]').serialize(),success:function(data){
                $('form[name="forgot_password_form"] .has-spinner').removeClass('active');

                if(data.status == 'ok'){
                    form_submit_response('form[name="forgot_password_form"]','success',data.message,true);
                    $('form[name="forgot_password_form"] input:text').val('');
                }else if(data.status == 'error') {
                    form_submit_response('form[name="forgot_password_form"]','danger',data.error);
                }else{
                    form_submit_response('form[name="forgot_password_form"]','danger','An unknown error occurred. Please contact support@fnl-guide.com');
                }

            }});
        }
    });
}
function resetPasswordForm(){
    $('form[name="reset_password_form"]').addClass('ready');
    $('form[name="reset_password_form"]').validate({
        rules: {
            password:{
                required:true,
                minlength: 6
            },
            password_verify: {
                minlength: 6,
                equalTo: "#password"
            },
            email: {
                required: true,
                email: true
            }
        },
        messages:{
            'email':'Required',
            'password':'Required',
            'password_verify':'Required'
        },
        submitHandler: function() {
            $.ajax({data:$('form[name="reset_password_form"]').serialize(),success:function(data){
                if(data.status == 'ok'){
                    form_submit_response('form[name="reset_password_form"]','success',data.message,true);
                    $('form[name="reset_password_form"] input:text').val('');
                    $('form[name="reset_password_form"] input:password').val('');
                    setTimeout(function(){
                        window.location = SITE_URL + 'my-fnl:login/';
                    },2000)
                }else if(data.status == 'error') {
                    form_submit_response('form[name="reset_password_form"]','danger',data.error);
                }else{
                    form_submit_response('form[name="reset_password_form"]','danger','An unknown error occurred. Please contact support@fnl-guide.com');
                }
            }});
        }
    });
}
function confirmation(callback,id,message){
    var c = confirm(message);
    if(c){
        callback(id);
    }
}
function scroll2element(el)
{
    setTimeout(function(){
        var position = $(el).offset();
        var y = position.top - ($('#header_wrapper').height() +50);
        $('html, body').stop().animate({scrollTop: y}, 'slow');
    },500);
}
function form_submit_response(target,type,message){
    $(target).find('.alert').remove();
    scroll2element($(target));
    $(target).prepend($('<div class="alert alert-'+type+' text-center" style="position:fixed;top:0;left:0;right:0; text-align:center;z-index:99999" >'+message+'</div>'));
    $(target).find('.alert').fadeIn('slow');
    setTimeout(function(){
        $(target).find('.alert').slideUp('slow',function(){
            $(this).remove();
        });
    },5000);

}
